import AdminResultEntry from './AdminResultEntry';
import AdminResultAssessmentTabs from './AdminResultAssessmentTabs';

const AdminEnterCA = () => (
  <AdminResultAssessmentTabs>
    <AdminResultEntry assessmentType="ca" />
  </AdminResultAssessmentTabs>
);

export default AdminEnterCA;
